<ng-container [ngSwitch]="docFormat">
  <ng-container *ngSwitchCase="'PDF'">
    <div style="min-height: 600px">
      <ngx-extended-pdf-viewer [src]="docSrc" useBrowserLocale="true" height="100%"></ngx-extended-pdf-viewer>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'PNG'" [ngTemplateOutlet]="image"></ng-container>
  <ng-container *ngSwitchCase="'JPG'" [ngTemplateOutlet]="image"></ng-container>
  <ng-container *ngSwitchCase="'GIF'" [ngTemplateOutlet]="image"></ng-container>
  <ng-container *ngSwitchCase="'JPEG'" [ngTemplateOutlet]="image"></ng-container>
  <ng-container *ngSwitchDefault>
    <div class="{{ docFormat == 'NA' ? 'noPreviewWrapper' : '' }}">
      <div class="noDocData noPreview text-center">
        <p>No Preview Available</p>
        <p class="subtext">Use the download link below.</p>
        <button class="btn btn-primary" (click)="downloadDocument()">Download</button>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #image><img src="{{ docSrc }}" alt="Image Source" /></ng-template>
